/**
 * Pillar Constants - Four Literacy Pillars
 *
 * Defines colors, icons, and metadata for the four literacy pillars.
 * Used across learning view badges, progress bars, and level navigation.
 */

export const PILLARS = {
  'digital': {
    name: 'Digital Literacy',
    shortName: 'Digital',
    color: 'blue',
    bgColor: 'bg-blue-900/30',
    borderColor: 'border-blue-500',
    textColor: 'text-blue-400',
    progressColor: 'bg-blue-500',
    icon: '💻',
    description: 'Understanding how computers, data, and programs work'
  },
  'ai': {
    name: 'AI Literacy',
    shortName: 'AI',
    color: 'purple',
    bgColor: 'bg-purple-900/30',
    borderColor: 'border-purple-500',
    textColor: 'text-purple-400',
    progressColor: 'bg-purple-500',
    icon: '🤖',
    description: 'Understanding AI reasoning, limitations, and human responsibility'
  },
  'problem-solving': {
    name: 'Problem-Solving Literacy',
    shortName: 'Problem-Solving',
    color: 'amber',
    bgColor: 'bg-amber-900/30',
    borderColor: 'border-amber-500',
    textColor: 'text-amber-400',
    progressColor: 'bg-amber-500',
    icon: '🧩',
    description: 'Breaking down problems and systematic thinking'
  },
  'economic': {
    name: 'Economic Literacy',
    shortName: 'Economic',
    color: 'green',
    bgColor: 'bg-green-900/30',
    borderColor: 'border-green-500',
    textColor: 'text-green-400',
    progressColor: 'bg-green-500',
    icon: '💡',
    description: 'Understanding value, resources, and sustainability'
  }
};

/**
 * Get pillar metadata by key
 */
export function getPillar(pillarKey) {
  return PILLARS[pillarKey] || PILLARS['problem-solving']; // fallback to problem-solving
}

/**
 * Get pillar color classes for Tailwind
 */
export function getPillarColors(pillarKey) {
  const pillar = getPillar(pillarKey);
  return {
    bg: pillar.bgColor,
    border: pillar.borderColor,
    text: pillar.textColor,
    progress: pillar.progressColor
  };
}
